<template>
  <div class="z1">
    <footer class="pt-4 bgrojo ">
      <div class="container-fluid">
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-12 text-center">
            <div
              class="blanco fG2 bold d-flex justify-content-center align-items-center"
            >
              <span class="pb-3">
                <a
                  target="_blank"
                  href="https://www.instagram.com/arreglalomx/"
                >
                  <img
                    class="px-1"
                    width="50"
                    src="../assets/imgs/arreglalo/icons/ico_ig.svg"
                    alt="Instagram"
                  />
                </a>
              </span>
              <span class="pb-3">
                <a target="_blank" href="https://www.facebook.com/Arreglalo">
                  <img
                    class="px-1"
                    width="50"
                    src="../assets/imgs/arreglalo/icons/ico_fb.svg"
                    alt="Facebook"
                  />
                </a>
              </span>
            </div>

            <p class="blanco fG2 pb-3 bold">
              <span class="border-bottom pb-3 px-5"> ¡SÍGUENOS EN REDES! </span>
            </p>

            <p class="blanco fG2 bold">CONTÁCTANOS</p>

            <p class="blanco fR">
              Tel. Corporativo
              <a class="" href="tel:555634725248">(55) 56 3472 5248</a> <br />
            </p>

            <p class="blanco fR">
              e-mail Corporativo
              <a class="underlined" href="mailto:comentarios@arreglalo.com.mx"
                >comentarios@arreglalo.com.mx</a
              >
            </p>

            <p class="blanco fC bold">¡Respondemos inmediatamente tu correo!</p>

            <div class="blanco fC bold mb-4 pb-3 row">
              <div class="col-10 offset-1 col-md-6 offset-md-3">
                <div class="border-bottom pb-3 px-5">
                  Si no encuentras nuestra respuesta búscanos en tu bandeja de
                  "correos no deseados".
                </div>
              </div>
            </div>

            <div class="blanco fC row">
              <div class="col-10 offset-1 col-md-6 offset-md-3">
                <div class="row">
                  <div class="pb-3 pt-2 border-lg-right pr-lg-4 col-md-6">
                    <router-link class="underlined" to="/aviso-de-privacidad">
                      Consulta nuestro Aviso de Privacidad
                    </router-link>
                  </div>

                  <div class="pb-3 pt-2 pl-lg-4 col-md-6">
                    <router-link
                      class="underlined"
                      to="/terminos-y-condiciones"
                    >
                      Consulta las condiciones del servicio
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <p class="blanco fC mb-4 pt-3">
              &copy; Copyright Arréglalo 2023. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>

    <div class="container bg-white">
      <div class="row py-5">
        <div class="col-10 offset-1 col-md-4 offset-md-4">
          <div class="row d-flex align-items-center">
            <div class="col-6 border-right-gray">
              <p class="grisoscuro text-center bold pt-2">Socio AMF</p>
              <a href="https://amfranquicias.mx/" target="_blank">
                <img
                  width="150"
                  src="../assets/imgs/arreglalo/logos/logo_amf.png"
                  alt="Asociación Mexicana de Franquicias"
                />
              </a>
            </div>
            <div class="col-6 pl-lg-4 text-center">
              <p class="grisoscuro text-center bold">Asesorado por</p>
              <a target="_blank" href="https://feherandfeher.com/">
                <img
                  width="70"
                  src="../assets/imgs/arreglalo/logos/logo_feher.png"
                  alt="Asociación Mexicana de Franquicias"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

